import produce from 'immer';
import * as _ from 'lodash';
import type { Action } from 'redux';

import { createReducer } from '../utils';

import { SET_NAV_STATE } from './actions';
import type { NavigationState } from './types';

const initialState: NavigationState = {
  navProps: {},
  expand: null,
  subnav: null,
};

type SetNavAction = Action<'SET_NAV_STATE'> & {
  payload: Partial<NavigationState>;
};

const NavigationReducer = createReducer<NavigationState>(initialState, {
  [SET_NAV_STATE]: (state: NavigationState, action: SetNavAction) => produce(state, draftState => {
    draftState.navProps = _.assignIn({}, state.navProps || {}, action.payload.navProps);

    // Undefined check because null is an acceptable value.
    draftState.expand = action.payload.expand === undefined ? state.expand : action.payload.expand;
    draftState.subnav = action.payload.subnav === undefined ? state.subnav : action.payload.subnav;
  }),
});

export default NavigationReducer;
